import { Attribute, Relationship, Resource } from 'json-api';
import { AtomResource } from '../classes/atom-resource';
import { AcquisitionMapping } from './acquisition-mapping.resource';
import { Users } from './user.resource';
import {
  ResourceConfig,
  ResourceConfigOne,
} from 'src/app/resources/resources-interfaces/resource-config';
import { NumberFilter, StringFilter } from 'src/app/filter/filter';
import { AtomService } from '../atom.service';
import { UsersConfig } from 'src/app/shared/tools/search/search-config';

@Resource({
  type: 'trafficmanagers',
})
export class TrafficManager extends AtomResource {
  @Attribute() name?: string;
  @Attribute() data?: Record<string, unknown>;

  @Relationship() acquisitionmappings?: AcquisitionMapping[];
  @Relationship() user?: Users;
}

export class TrafficManagersConfig implements ResourceConfig {
  tables = {
    includes: [
      'user',
      'acquisitionmappings.acquisitionsource',
      'acquisitionmappings.acquisitionaccount',
    ],
    columns: [
      {
        columnDef: 'id',
        displayedDatas: [{ path: ['id'], class: 'main', translatable: false }],
        header: 'ID',
        translatable: false,
        displayed: true,
      },
      {
        columnDef: 'name',
        displayedDatas: [
          {
            path: ['name'],
            class: 'main',
            translatable: false,
          },
        ],
        header: 'Name',
        translatable: false,
        displayed: true,
        link: {
          detail: true,
        },
      },
      {
        columnDef: 'acquisitionmappings',
        header: 'Mappings',
        translatable: false,
        displayed: true,
        link: {
          resource: 'acquisitionmappings',
          list: 'acquisitionmappings',
          target: 'trafficmanagers',
        },
      },
      {
        columnDef: 'user',
        displayedDatas: [
          { path: ['user.id'], class: 'main', translatable: false },
        ],
        header: 'User',
        translatable: false,
        displayed: true,
      },
      {
        columnDef: 'createdAt',
        displayedDatas: [
          {
            path: ['meta.created_at'],
            class: 'main',
            date: true,
          },
          {
            path: ['meta.createUser.name'],
            class: 'mat-body-1',
            date: true,
          },
        ],
        header: 'Updated At',
        displayed: true,
      },
      {
        columnDef: 'updatedAt',
        displayedDatas: [
          {
            path: ['meta.updated_at'],
            class: 'main',
            date: true,
          },
          {
            path: ['meta.updateUser.name'],
            class: 'mat-body-1',
            date: true,
          },
        ],
        header: 'Updated At',
        displayed: true,
      },
      {
        columnDef: 'actions',
        header: 'Actions',
        translatable: false,
        displayed: true,
      },
    ],
  };
  detail: ResourceConfigOne = {
    header: {
      icon: 'person',
      title: [
        {
          path: ['name'],
          translatable: false,
        },
      ],
      id: true,
    },
    elements: [
      {
        showEmpty: true,
        list: [
          {
            icon: 'merge',
            title: 'Mappings',
            APIKey: 'acquisitionmappings',
            value: {
              path: ['acquisitionmappings'],
              translatable: false,
            },
            link: {
              resource: 'acquisitionmappings',
              list: 'acquisitionmappings',
              target: 'trafficmanager',
            },
            options: {
              sort: {
                type: 'date',
                link: {
                  resource: 'acquisitionmappings',
                  filter: 'acquisitionmappings.id',
                  list: 'acquisitionmappings',
                  target: 'trafficmanagers',
                },
                displayedDatas: [
                  {
                    columnDef: 'acquisitionsource',
                    title: 'Source',
                    path: ['acquisitionsource.name'],
                    class: 'main',
                    translatable: false,
                  },
                  {
                    columnDef: 'acquisitionaccount',
                    title: 'Account',
                    path: [
                      'acquisitionaccount.name',
                      'acquisitionaccount.account',
                    ],
                    class: 'main',
                    translatable: false,
                  },
                ],
              },
            },
          },
        ],
      },
    ],
  };
  wizard = {
    tabs: [
      {
        title: 'Traffic Manager',
        formGroup: 'trafficmanager',
        list: [
          {
            type: 'text',
            title: 'Name',
            formControl: 'name',
            required: true,
          },
          {
            type: 'resource',
            title: 'User',
            formControl: 'user',
            search: new UsersConfig(),
            required: true,
          },
        ],
      },
    ],
  };
  resource = TrafficManager;
  resourceName = 'Traffic Manager';
  resourceKey = 'trafficmanagers';
  includes = [
    'user',
    'acquisitionmappings.acquisitionsource',
    'acquisitionmappings.acquisitionaccount',
  ];
  filters = [
    new NumberFilter('id', 'ID'),
    new StringFilter('name', 'Name', true),
  ];
  constructor(private atom: AtomService) {}
}
